






















































































































import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import DateTimePicker from '@/components/form/DateTimePicker.vue';
import FormSelector from '@/components/form/FormSelector.vue';
import FormCheckbox from '@/components/form/FormCheckbox.vue';
import MultiCheckboxFilter from '@/components/form/MultiCheckboxFilter.vue';
import FormInput from '@/components/form/FormInput.vue';
import { Responsible } from '@/model/Responsible';
import { Topic } from '@/model/Topic';
import { Location } from '@/model/Location';
import { EventFlowFilterData } from '@/model/event-flow/EventFlow';
import { MultiCheckboxFilterItem } from '@/model/form/FormItem';

@Component({
    components: {
        DateTimePicker,
        FormCheckbox,
        FormInput,
        FormSelector,
        MultiCheckboxFilter,
    },
})
export default class EventFlowFilter extends Vue {
    @Model('change', { type: Object }) form!: EventFlowFilterData;
    @Prop(Array) readonly responsibles!: Responsible[];
    @Prop(Array) readonly locations!: Location[];
    @Prop(Array) readonly topics!: Topic[];

    isFilterOpen = false;

    formData = { ...this.form };

    toggleFilterOpen(): void {
        this.isFilterOpen = !this.isFilterOpen;
    }

    get responsibleOptions(): MultiCheckboxFilterItem[] {
        return this.responsibles.map((responsible) => {
            return {
                value: responsible.id,
                name: responsible.name ?? '',
                color: responsible.color ?? '',
            } as MultiCheckboxFilterItem;
        });
    }

    get locationOptions(): MultiCheckboxFilterItem[] {
        return this.locations.map((location) => {
            return {
                value: location.id,
                name: location.name ?? '',
            } as MultiCheckboxFilterItem;
        });
    }

    get topicOptions(): MultiCheckboxFilterItem[] {
        return this.topics.map((topic) => {
            return {
                value: topic.id,
                name: topic.name ?? '',
            } as MultiCheckboxFilterItem;
        });
    }

    onResetFilters(): void {
        this.formData.search = '';
        this.formData.responsibleFilters = [];
        this.formData.locationFilters = [];
        this.formData.topicFilters = [];
        this.$emit('change', { ...this.formData });
    }

    onFilter(): void {
        this.isFilterOpen = false;
        this.$emit('change', { ...this.formData });
    }
}
